<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ShareRulemy',
})
</script>
<template>
  <div class="page">
    <header>
      <NavBar :title="lang('rule')" transparent> </NavBar>
    </header>
    <main>
      <div class="title">Penerima yang Layak:</div>
      <div class="text">Ahli Aplikasi J&T Malaysia</div>
      <div class="title">Butiran Kelebihan:</div>
      <div class="serial_wrap">
        <div class="serial">1.</div>
        <div class="text">
          Setiap ahli boleh mendapatkan mata dengan mengajak rakan. Setiap rakan
          yang dirujuk menjadi ahli baru, ahli baru mesti memasukkan kod rujukan
          yang diberikan oleh pengganti, dan sistem akan memberikan 1,000 mata
          kepada pengganti.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">2.</div>
        <div class="text">
          Sistem akan secara automatik memberikan pakej selamat datang kepada
          setiap pengguna baru. Kandungan pakej adalah:
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">1,000 mata</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">Satu baucar tunai RM2</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">Dua baucar tunai RM1</div>
          </div>
          <div class="serial_wrap">
            <div class="serial_round"></div>
            <div class="text">Satu baucar tunai antarabangsa RM5</div>
          </div>
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">3.</div>
        <div class="text">
          Selepas pengguna baru membuat pesanan dan membayar, sistem akan
          memberikan ganjaran kepada pengganti seperti berikut:
          <div class="serial_wrap">
            <div class="serial">a.</div>
            <div class="text">
              Pengganti Permulaan:
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">500 mata</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">Satu baucar tunai RM6</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">Satu baucar tunai antarabangsa RM5</div>
              </div>
            </div>
          </div>
          <div class="serial_wrap">
            <div class="serial">b.</div>
            <div class="text">
              Pengganti Teratas:
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">500 mata</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">Satu baucar tunai RM6</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">Satu baucar tunai antarabangsa RM5</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">Dua baucar tunai next-day delivery RM3</div>
              </div>
              <div class="serial_wrap">
                <div class="serial_rect"></div>
                <div class="text">Dua baucar tunai RM2</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">4.</div>
        <div class="text">
          Pengganti Permulaan merujuk kepada ahli sedia ada yang berjaya
          menjemput 4 pengguna baru pertama untuk membuat pesanan dan
          pembayaran, manakala Pengganti Teratas merujuk kepada ahli sedia ada
          yang berjaya menjemput pengguna baru ke-5 hingga ke-8 untuk membuat
          pesanan dan pembayaran.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">5.</div>
        <div class="text">
          Ganjaran mata referal dan ganjaran kupon terhad kepada pengguna baru
          ke-8.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">6.</div>
        <div class="text">
          Baucar adalah sah selama 90 hari dari tarikh pengeluaran atau tarikh
          pengguna menebusnya, mana yang lebih lewat.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">7.</div>
        <div class="text">
          Mata adalah sah selama 365 hari dari tarikh pengeluaran atau tarikh
          pengguna menebusnya, mana yang lebih lewat.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">8.</div>
        <div class="text">
          Jika akaun pengguna dikenalpasti sebagai akaun berisiko oleh J&T
          semasa acara ini, atau jika pengguna terlibat dalam penipuan mesin
          atau aktiviti lain yang tidak sah, penganjur akan membatalkan
          kelayakan peserta dan berhak untuk menarik balik ganjaran yang
          berkaitan, dan mengambil tindakan undang-undang jika perlu.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">9.</div>
        <div class="text">
          Dalam keadaan force majeure atau perubahan keadaan (termasuk tetapi
          tidak terhad kepada kejadian bencana besar, aktiviti yang memerlukan
          penamatan atau penyesuaian oleh arahan kerajaan, serangan siber yang
          teruk, atau kegagalan sistem), J&T berhak untuk menghentikan atau
          membatalkan acara ini dan menghentikan pengeluaran manfaat berkaitan.
        </div>
      </div>
      <div class="serial_wrap">
        <div class="serial">10.</div>
        <div class="text">
          J&T boleh mengubah atau menyesuaikan peraturan acara berdasarkan
          pelaksanaan sebenar acara tersebut, dan sebarang perubahan akan
          diumumkan di halaman acara dan berkuatkuasa serta-merta selepas
          pengumuman.
        </div>
      </div>
    </main>
  </div>
</template>

<script lang="ts" setup name="ShareRulemy">
import NavBar from '@/components/NavBar.vue'
import lang from '@/langs'
// import { useRouter } from 'vue-router'

// const router = useRouter()
</script>

<style lang="less" scoped>
.page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  :deep(.van-icon-arrow-left) {
    color: #fff !important;
  }
  :deep(.van-nav-bar__title) {
    color: #fff !important;
  }
  :deep(.van-nav-bar__content) {
    background: #e92124 !important;
  }
  .header_right {
    .flex_align_center;
  }
  .right_filter {
    width: 12px;
    height: 13px;
  }
}
header {
  width: 100%;
}
main {
  flex: 1;
  overflow-y: auto;
  margin-top: 10px;
  padding: 10px;
  padding-top: 0;
}
.title {
  font-size: 17px;
  font-weight: bold;
  color: #333333;
  line-height: 17px;
  margin-top: 20px;
}
.text {
  font-size: 16px;
  color: #333333;
  line-height: 21px;
  margin-top: 6px;
}
.serial_wrap {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2px;
}
.serial {
  color: #336df2;
  font-size: 16px;
  line-height: 21px;
  margin-top: 6px;
  margin-right: 6px;
}
.serial_round {
  width: 5px;
  height: 5px;
  border-radius: 3px;
  border: 1px solid #336df2;
  background: #fff;
  margin-right: 6px;
  margin-top: 13px;
}
.serial_rect {
  width: 4px;
  height: 4px;
  border: 1px solid #336df2;
  background: #336df2;
  margin-right: 6px;
  margin-top: 13px;
}
</style>
